// @flow
export const AVAILABLE_NATIONWIDE = 'Available Nationwide';
export const NATIONWIDE = 'Nationwide';
export const IOSAPPSTOREURL =
  'https://apps.apple.com/us/app/hitchpin-agriculture/id1384296867';
export const IOSAPPURL = 'HitchPin://';
export const MOBILE_BREAKPOINT = 900;
export const STATE_FILTER_TEXT = 'State';
export const RESULTS_INCLUDE_FILTER_TEXT = 'Results Include';
export const LISTING_TYPE_FILTER_TEXT = 'Buying or Selling?';
export const SORT_BY_FILTER_TEXT = 'Sort By';
export const PRODUCTS_OR_SERVICES = 'Products or Services';
// This regular expression expression lists many descriptors of bots from user agents, was taken from hp-core
export const BOT_USER_AGENTS = /googlebot|bingbot|yandex|baiduspider|Facebot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkShare|W3C_Validator/i;
export const SUPPORT_PHONE_NUMBER_DISPLAY = '(785) 522-4278';
export const SUPPORT_PHONE_NUMBER = '785-522-4278';
export const ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const LAYOUT_STORE_NAME = 'LayoutStore';
